import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

//分区配置
const apiConst = {
  // 类型常量
  zone_type_constant:
    baseAPI + baseUrl + 'official/zone_config/zone_type_constant',
  // 配置列表
  //   查询
  zone_type_query: baseAPI + baseUrl + 'official/zone_config/zone_config_query',
  //   添加
  zone_type_add: baseAPI + baseUrl + 'official/zone_config/zone_config_add',
  //   修改
  zone_type_change:
    baseAPI + baseUrl + 'official/zone_config/zone_config_change',
  //   详情
  //   查询
  zone_config_detail:
    baseAPI + baseUrl + 'official/zone_config/zone_config_detail',
  //   添加
  zone_config_detail_add:
    baseAPI + baseUrl + 'official/zone_config/zone_config_detail_add',
  //   修改
  zone_config_detail_change:
    baseAPI + baseUrl + 'official/zone_config/zone_config_detail_change',
  //   配置地区
  //   标签常量
  zone_label_name_list:
    baseAPI + baseUrl + 'official/zone_config/zone_label_name_list',
  //   列表查询
  zone_label_list: baseAPI + baseUrl + 'official/zone_config/zone_label_list',
  //   添加
  zone_label_add: baseAPI + baseUrl + 'official/zone_config/zone_label_add',
  //   修改
  zone_label_change:
    baseAPI + baseUrl + 'official/zone_config/zone_label_change',
}

// 类型常量获取
export const getZonTypeCon = async () => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.zone_type_constant,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
  })
  return res
}

// 配置列表
//   查询
export const getZonTypeList = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.zone_type_query,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params,
    },
  })
  return res
}

//   添加
export const getZonTypeAdd = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.zone_type_add,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params,
    },
  })
  return res
}

//   修改
export const getZonTypeChange = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.zone_type_change,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

//   详情
//   查询
export const getZonConfigQuery = async (zoneTypeId) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.zone_config_detail,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      zoneTypeId
    },
  })
  return res
}

//   添加
export const getZonConfigAdd = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.zone_config_detail_add,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

//   修改
export const getZonConfigChange = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.zone_config_detail_change,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

//   配置地区
//   标签常量
export const getZonNameList = async () => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.zone_label_name_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
  })
  return res
}

//   列表查询
export const getZonLabelList = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.zone_label_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params,
    },
  })
  return res
}

//   列表添加
export const getZonLabelAdd = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.zone_label_add,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

//   列表修改
export const getZonLabelChange = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.zone_label_change,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}
